import { makeGet } from './ServiceManager';
import { adAccountIds as nuAccountIds } from './../constants/nissan-united';

const filterAccounts = (accounts, userGroup) => {
  let finalAccounts = accounts;

  // switch case leaves room for expansion to other clients in the future
  switch (userGroup) {
    case 'NU':
      finalAccounts = accounts.filter((accountObj) =>
        nuAccountIds.includes(`${accountObj.account_id}`)
      );
      break;
    default:
      break;
  }

  return finalAccounts;
};

export const getAccounts = async (userGroup) => {
  let accounts = window.sessionStorage.getItem('accounts');

  if (accounts) {
    return filterAccounts(JSON.parse(accounts), userGroup);
  }

  accounts = [];

  const result = await makeGet('service/accounts');

  if (result.statusCode === 200) {
    accounts = filterAccounts(
      result.accounts.owned_ad_accounts.data,
      userGroup
    );
    accounts = accounts.concat(
      filterAccounts(result.accounts.client_ad_accounts.data, userGroup)
    );
    window.sessionStorage.setItem('accounts', JSON.stringify(accounts));
    return accounts;
  }

  return accounts;
};

export const refreshAccounts = async (userGroup) => {
  let accounts = window.sessionStorage.removeItem('accounts');

  if (accounts) {
    return filterAccounts(JSON.parse(accounts), userGroup);
  }

  accounts = [];

  const result = await makeGet('service/accounts');

  if (result.statusCode === 200) {
    accounts = filterAccounts(
      result.accounts.owned_ad_accounts.data,
      userGroup
    );
    window.sessionStorage.setItem('accounts', JSON.stringify(accounts));
    return accounts;
  }

  return accounts;
};



// WEBPACK FOOTER //
// ./src/services/AccountService.js